import React from "react";

export const useSelectionActionHandlers = ({
	actionOnSelectionPallet,
	handlePalletReservationSelection,
	updateRecordsOnPalletSelection,
}) => {
	React.useEffect(() => {
		const handleOnActionOnSelectionPallet = (pallet) => {
			handlePalletReservationSelection(pallet);
			updateRecordsOnPalletSelection(pallet.id, true);
		};
		actionOnSelectionPallet.current = handleOnActionOnSelectionPallet;
	}, [handlePalletReservationSelection, updateRecordsOnPalletSelection]);
};
